<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="modal-header checkout-popup-header">
      <h4 class="modal-title" id="modal-basic-title">
        {{ 'quote.updatedCart' | cxTranslate }}
      </h4>
    </div>
    <div class="modal-body checkout-popup">
      <h3 class="confirmation-order">
        {{ 'quote.bulkshopping' | cxTranslate }}
      </h3>
      <div
        class="vs-checkbox custom-order-checkbox"
        *ngIf="nonSellableArr.length > 0"
      >
        <i class="material-icons custom-material-icon">report_problem</i>
        <p class="confirmation-order">
          <span *ngFor="let item of nonSellableArr; let i = index">
            {{ 'quote.bulkpart' | cxTranslate }} {{ item
            }}<span *ngIf="i < nonSellableArr.length - 1">,</span>
          </span>
          <span> {{ 'quote.bulkorderprice' | cxTranslate }} </span>
        </p>
      </div>
    </div>
    <div class="modal-footer checkout-popup-footer">
      <button
        class="vs-primary-btn"
        (click)="closeModal('ok-non-sellable-quote')"
      >
        <span>{{ 'quote.okBtn' | cxTranslate }}</span>
      </button>
    </div>
  </div>
</div>
